import React from 'react';
import { Box, FormControlLabel, FormGroup, Checkbox as MuiCheckbox, Tooltip, Stack } from '@mui/material';
import { useAuth } from 'lib/auth';
import { ReactComponent as LockIcon } from 'assets/LockClosed.svg';

const Checkbox = ({ disabled = false, name, label, onChange, checked }) => {
  return (
    <FormGroup>
      <FormControlLabel
        sx={{
          mr: 0,
          '&.Mui-disabled span': {
              color: "#000!important",
              opacity: 0.38,
            },
        }}
        label={label}
        control={
          <MuiCheckbox
            name={name}
            disabled={disabled}
            size="small"
            checked={checked}
            onChange={onChange}
          />
        }
      />
    </FormGroup>
  );
};

export const CheckboxFilter = ({
  adminOnly = false,
  companyAdmin = false,
  companyID = null,
  subscriptionTypes = [],
  tooltip = '',
  name,
  label,
  onChange,
  checked,
}) => {
  const {
    account: { super_admin },
    user
  } = useAuth();

  if (adminOnly && !super_admin) {
    return null;
  }

  if (!companyAdmin && !super_admin && (user.Company.company_id !== companyID || user.role !== "company_admin")) {
    return null;
  }

  if (subscriptionTypes.length && !subscriptionTypes.includes(user.Company.subscription_level) && !super_admin) {
    return (
      <Tooltip
        arrow
        title={tooltip}
        placement="top"
        slotProps={{ popper: { modifiers: [{ name: 'offset', options: { offset: [0, -14] } }] } }}
      >
        <Stack direction="row" alignItems="center"
          sx={({ palette }) => ({
            px:1,
          })}
        >
          <Checkbox disabled name={name} label={label} onChange={onChange} checked={checked} />
          <Stack
            sx={{
              pl:1,
              opacity: 0.38,
            }}
          >
            <LockIcon />
          </Stack>
        </Stack>
      </Tooltip>
    );
  }

  return <Checkbox name={name} label={label} onChange={onChange} checked={checked} />;
};
